import { Autocomplete, TextField, Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const LEGAL_FILE_TYPE_OPTIONS = [
  { id: "municipality", label: "MUNICIPALIDAD" },
  { id: "external", label: "COMÚN" },
];

export default function LegalFileTypeFilter({
  value,
  onChange,
  label = "Tipo de expediente",
}) {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={LEGAL_FILE_TYPE_OPTIONS}
      value={value}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      getOptionLabel={(option) => option.label}
      onChange={(_, newValue) => onChange(newValue)}
      renderOption={(props, option, { selected }) => {
        const { key, ...rest } = props;
        return (
          <li key={key} {...rest}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              checked={selected}
              size="small"
              sx={{ mr: 1 }}
            />
            {option.label}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Todos" />
      )}
    />
  );
}
